module.exports = {
	"classes": [
		"single-sign-on"
	],
	"title": "Single Sign On: Log in. Just Once",
	"metas": {
		"description": "With Single Sign On, you can provide your customers, partners and employees with a seamless authentication experience when they navigate either through the applications you have built and/or third party apps."
	},
	"opengraph": {
		"og:title": "Single Sign On: Log in. Just Once",
		"og:description": "With Single Sign On, you can provide your customers, partners and employees with a seamless authentication experience when they navigate either through the applications you have built and/or third party apps.",
		"og:url": "https://auth0.com/single-sign-on",
		"og:image": "http://cdn.auth0.com/website/single-sign-on/sso-twitter-card",
		"og:image:secure_url": "https://cdn.auth0.com/website/single-sign-on/sso-twitter-card"
	},
	"twittercard": {
		"twitter:title": "Single Sign On: Log in. Just Once",
		"twitter:description": "With Single Sign On, you can provide your customers, partners and employees with a seamless authentication experience when they navigate either through the applications you have built and/or third party apps.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/single-sign-on/sso-twitter-card"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/single-sign-on/metadata.json
// module id = 1434
// module chunks = 0